<div class="control-section" id="wrapper">
	<!-- Navigation Bar - main content declaration -->
	<nav class="navbar sitenavbar navbar-expand-lg">
		<span (click)="dockBar.toggle()" *ngIf="(auth.isAuthenticated$ | async ) == true" class="alignRow"
			style="margin-right: 1em;">
			<mat-icon *ngIf="!dockBar.isOpen" title="Open Side Menu">menu</mat-icon>
			<mat-icon *ngIf="dockBar.isOpen" title="Close Side Menu">menu_open</mat-icon>
		</span>
		<div fxHide.lt-xs="true" class="alignRow">
			<app-prismPDM-logo
				[customStyles]="{'height': '35px','margin-right':'var(--default-margin)'}"></app-prismPDM-logo>
			<ng-container *ngTemplateOutlet="devMessage"></ng-container>
		</div>
		<span class="me-auto"></span>
		<span class="alignRow">
			<span class="nav-item alignRow" style="font-size: smaller;" *ngIf="hostName=='dev.prismpdm.io'">
				<span>Beta Testing Site</span>
				<mat-icon style="color: red;margin-right: 1em;">logo_dev</mat-icon>
			</span>
			<ng-container *ngIf="auth.isAuthenticated$ | async; then loggedIn else NotloggedIn"> </ng-container>
		</span>
	</nav>

	<!-- Side Bar Navigation -->
	<div style="margin: var(--default-margin); margin-bottom: 0px; margin-left: 0px;">
		<div id="main-content" class="dockmaincontent">
			<div id="dockContent" class="dockcontent">
				<router-outlet></router-outlet>
			</div>
		</div>
		<ejs-sidebar id="dockSidebar" #dockBar class="dockSidebar e-hidden" [width]="width" dockSize="40px"
			target=".dockmaincontent" [enableDock]='enableDock' [type]="dockBarMode" [isOpen]="dockIsOpen"
			[enableGestures]="false" [enablePersistence]="true" [closeOnDocumentClick]="isMobile"
			(open)="adjustContent()" (close)="adjustContent()" style="padding-top: 0.5em;">
			<span class="sidebar" *ngIf="(auth.isAuthenticated$ | async )">
				<div *ngIf="dockBar.isOpen && selectedAccount">
					<img [src]="imagePathAccounts() + selectedAccount.ID + '?' + selectedAccount.Modified"
						style="width: 75%;padding: 5px; max-width: 75%; height: 150px; object-fit: contain; object-position: center;"
						onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
						[attr.x-contenttype]="'image/png'" />
					<mat-divider></mat-divider>
				</div>
				<ng-container *ngIf="dockBar.isOpen; then navigationOpen else navigationCollapsed"></ng-container>
			</span>
		</ejs-sidebar>
	</div>
</div>

<!-- Navigation Bar - Development Server Message -->
<ng-template #devMessage>
	<span fxHide.lt-sm *ngIf="!env.production && hostName!='dev.prismpdm.io'" style="color: red; font-size: larger;">
		Development Server:{{env.apiUrl}}
	</span>
</ng-template>

<!-- Navigation Bar - No one is logged in -->
<ng-template #NotloggedIn>
	<span class="navbar-nav me-auto mb-2 mb-lg-0"></span>
	<span class="app-icon app-icon--login" mat-icon-button (click)="auth.loginWithRedirect()"
		title="Log in"><mat-icon /></span>
</ng-template>

<!-- Navigation Bar - User Logged in to website -->
<ng-template #loggedIn>
	<!-- Adds a navigation button on the right if the sceen gets smaller -->
	<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
		aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
		<mat-icon style="color:red">menu</mat-icon>
	</button>

	<!-- Defines the menu system thats on the Nav Bar -->
	<div class="collapse navbar-collapse" id="navbarSupportedContent">
		<!-- Load logged in template -->
		<span class="navbar-nav me-auto mb-2 mb-lg-0"></span>
		<!-- <span>{{updateAvailable}}<button (click)="updateAvailable = true;">Test</button></span> -->
		<ul class="navbar-nav alignColumnRight" style="font-size: smaller;color: whitesmoke;">
			<li class="nav-item" style="white-space: nowrap;" *ngIf="auth.user$ | async as user">
				<span>{{user.name}}</span>
			</li>
			<li class="nav-item" style="white-space: nowrap;">
				<span class="alignRow">
					<ng-container *ngTemplateOutlet="OrgDropdownHeader"></ng-container>
					<ng-container
						*ngTemplateOutlet="AccountDropdown; context: {showLabel:false, selectedAccount: selectedAccount, accounts:Accounts}"></ng-container>
				</span>
			</li>
		</ul>
		<!-- *ngIf="selectedAccount"  -->
		<span class="navbar-nav" style="padding-left: 10px;">
			<img *ngIf="auth.user$ | async as user" class="rounded-circle" src="{{user.picture}}"
				[matMenuTriggerFor]="userAccountMenu" style="height:50px;width:50px;"
				[attr.x-contenttype]="'image/png'">
			<ng-container *ngIf="(updateAvailable || myInvites.length != 0) then NotificationBadge" />
		</span>
	</div>
</ng-template>

<!-- Navigation Bar - Profile Image -->
<ng-template #profileImage>
	<ng-container *ngIf="dockBar.isOpen" class="profile-container">
		<div class="profile-image-wrapper">
			<img mat-button *ngIf="auth.user$ | async as user" class="nav-profile-image rounded-circle"
				[matMenuTriggerFor]="userAccountMenu" matTooltip="My Profile {{ user.email}}" src="{{user.picture}}"
				matTooltipPosition="right" [attr.x-contenttype]="'image/png'">
			<span *ngIf="myInvites.length != 0" class="notification-badge">{{ myInvites.length }}</span>
		</div>
		<h4 *ngIf="thisUser">{{ thisUser.Name }}</h4>
	</ng-container>
	<ng-container *ngIf="!dockBar.isOpen">
		<span class="alignRow" mat-button *ngIf="auth.user$ | async as user" [matMenuTriggerFor]="userAccountMenu"
			matTooltip="My Profile {{ user.email}}" matTooltipPosition="right">
			<mat-icon>person</mat-icon>
		</span>
	</ng-container>
	<mat-divider></mat-divider>
</ng-template>

<ng-template #AccountDropdown let-showLabel="showLabel" let-selectedAccount="selectedAccount" let-accounts="accounts">
	<span *ngIf="accounts.length <= 1 && selectedAccount">{{selectedAccount.Name}}</span>
	<span *ngIf="accounts.length > 1 && selectedAccount">
		<mat-label *ngIf="showLabel">Select Account</mat-label>
		<div class="dropdown " *ngIf="selectedAccount">
			<button class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
				style="min-width: 250px; padding: 0px; padding-left : 0.5rem;padding-right: 0.5rem; font-size: smaller;"
				matTooltip="Accounts Drop Down">
				{{selectedAccount.Name}}
			</button>
			<ul class="dropdown-menu dropdown-menu-end text-small shadow">
				<li *ngFor="let account of accounts">
					<a class="dropdown-item" (click)="SelectAccount(account.GUID)"
						[ngClass]="{'menuSelected': account.GUID === selectedAccount.GUID}">{{account?.Name}}</a>
				</li>
			</ul>
		</div>
	</span>
</ng-template>

<ng-template #OrgDropdownHeader>
	<span *ngIf="selectedOrganisation && Organisations.length > 1 && selectedAccountGUID !=''" class="alignRow"
		style="margin-left: 1em; margin-right: 1em;">
		<span>Site:&nbsp;</span>
		<div class="dropdown ">
			<button class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
				style="padding: 0px; padding-left : 0.5rem;padding-right: 0.5rem; font-size: smaller;"
				matTooltip="Accounts Drop Down">
				{{selectedOrganisation.Name}}
			</button>
			<ul class="dropdown-menu dropdown-menu-end text-small shadow">
				<li *ngFor="let org of Organisations">
					<a class="dropdown-item" (click)="SelectOrganisation(org.Uid)"
						[ngClass]="{'menuSelected': org.Uid === selectedOrganisation.Uid}">{{org?.Name}}</a>
				</li>
			</ul>
		</div>
	</span>
</ng-template>

<ng-template #OrgDropdownSideBar>
	<span *ngIf="selectedOrganisation && Organisations.length > 1 && selectedAccountGUID !=''">
		<ng-container *ngIf="dockBar.isOpen" class="alignColumn">
			<b><span>Select Site</span></b>
			<button class="btn btn-secondary " aria-expanded="false" style="width: 100%; padding:0px;"
				matTooltip="Change Site" matTooltipPosition="right" [matMenuTriggerFor]="changeOrganisation">
				<span>{{selectedOrganisation.Name}}</span>
				<span style="font-size: x-small;margin-left: 1rem;">&#9660;</span>
			</button>
		</ng-container>
		<ng-container *ngIf="!dockBar.isOpen">
			<span mat-button class="app-icon app-icon--factory" matTooltip="Change Organisation"
				matTooltipPosition="right" [matMenuTriggerFor]="changeOrganisation"><mat-icon /></span>
		</ng-container>
		<mat-divider></mat-divider>
	</span>
</ng-template>

<!-- Template for the Sidebar navigation links -->
<ng-template #navigationOpen>
	<ng-container *ngIf="selectedOrganisationUID !='' && SelectOrganisation">
		<ng-container *ngTemplateOutlet="NavigationButtons; context: { $implicit: navButtons }"> </ng-container>
		<div class="vert-spacer"></div>
		
		<!-- #35 Add an Account Expiry Warning and Trial warning -->
		<div><app-account-expiry [selectedAccount]="selectedAccount" /></div>

		<button *ngIf="updateAvailable" mat-menu-item (click)="reload()" matTooltip="App Update Available"
			matTooltipPosition="right">
			<mat-icon>system_update</mat-icon>
			<span>App Update Available</span>
			<!-- <ng-container *ngTemplateOutlet="NotificationBadge" /> -->
		</button>
		<ng-container *ngTemplateOutlet="NavigationButtons; context: { $implicit: adminButtons }"> </ng-container>
	</ng-container>
	
</ng-template>

<!-- Template for the Sidebar navigation links -->
<ng-template #navigationCollapsed>
	<ng-container *ngIf="selectedOrganisationUID !='' && SelectOrganisation">
		<ng-container *ngTemplateOutlet="NavigationIcons  context: { $implicit: navButtons }"> </ng-container>
		<div class="vert-spacer"></div>
		<span mat-button *ngIf="updateAvailable" (click)="reload()" matTooltip="App Update Available"
			matTooltipPosition="right" style="margin-bottom: 1em; color: red;">
			<mat-icon>system_update</mat-icon>
		</span>
		<ng-container *ngTemplateOutlet="NavigationIcons  context: { $implicit: adminButtons }"> </ng-container>
	</ng-container>
</ng-template>

<!-- Navigation buttons for Expanded Side Bar -->
<ng-template #NavigationButtons let-buttons>
	<ng-container *ngFor="let btn of buttons">
		<ng-container [ngSwitch]="btn.menu!"
			*ngIf="(!btn.featureFlag || checkFeature(btn.featureFlag)) && (!btn.accountAdmin || selectedAccount.Admin)">
			<button *ngSwitchCase="'settingsMenu'" mat-menu-item [class]="'app-icon app-icon--' + btn.iconClass"
				(click)="btn.clickFn ? btn.clickFn() : gotoRoute(btn.route!)" [matTooltip]="btn.tooltip!"
				matTooltipPosition="right" [matMenuTriggerFor]="settingsMenu">
				<mat-icon *ngIf="!btn.imgSrc" [ngClass]="btn.iconOutlined ? 'material-symbols-outlined':''"></mat-icon>
				<img *ngIf="btn.imgSrc" [src]="btn.imgSrc" class="mat-icon" alt="{{btn.label}}">
				<span>{{btn.label}}</span>
			</button>
			<button *ngSwitchCase="'supportMenu'" mat-menu-item [class]="'app-icon app-icon--' + btn.iconClass"
				(click)="btn.clickFn ? btn.clickFn() : gotoRoute(btn.route!)" [matTooltip]="btn.tooltip!"
				matTooltipPosition="right" [matMenuTriggerFor]="supportMenu">
				<mat-icon *ngIf="!btn.imgSrc" [ngClass]="btn.iconOutlined ? 'material-symbols-outlined':''"></mat-icon>
				<img *ngIf="btn.imgSrc" [src]="btn.imgSrc" class="mat-icon" alt="{{btn.label}}">
				<span>{{btn.label}}</span>
			</button>
			<button *ngSwitchDefault mat-menu-item [class]="'app-icon app-icon--' + btn.iconClass"
				(click)="btn.clickFn ? btn.clickFn() : gotoRoute(btn.route!)" [matTooltip]="btn.tooltip!"
				matTooltipPosition="right">
				<mat-icon *ngIf="!btn.imgSrc" [ngClass]="btn.iconOutlined ? 'material-symbols-outlined':''"></mat-icon>
				<img *ngIf="btn.imgSrc" [src]="btn.imgSrc" class="mat-icon" alt="{{btn.label}}">
				<span>{{btn.label}}</span>
			</button>
		</ng-container>
		<mat-divider *ngIf="btn.dividerAfter"></mat-divider>
	</ng-container>
</ng-template>

<!-- Navigation Icons for Collapsed Side Bar -->
<ng-template #NavigationIcons let-buttons>
	<div class="vertical-stack">
		<ng-container *ngFor="let btn of buttons">
			<ng-container [ngSwitch]="btn.menu!"
				*ngIf="(!btn.featureFlag || checkFeature(btn.featureFlag) && (!btn.accountAdmin || selectedAccount.Admin))">
				<span *ngSwitchCase="'settingsMenu'" mat-button [class]="'app-icon app-icon--' + btn.iconClass"
					(click)="btn.clickFn ? btn.clickFn() : gotoRoute(btn.route!)" [matTooltip]="btn.tooltip!"
					matTooltipPosition="right" [matMenuTriggerFor]="settingsMenu">
					<mat-icon *ngIf="!btn.imgSrc"
						[ngClass]="btn.iconOutlined ? 'material-symbols-outlined':''"></mat-icon>
					<img *ngIf="btn.imgSrc" [src]="btn.imgSrc" class="mat-icon" alt="{{btn.label}}">
				</span>
				<span *ngSwitchCase="'supportMenu'" mat-button [class]="'app-icon app-icon--' + btn.iconClass"
					(click)="btn.clickFn ? btn.clickFn() : gotoRoute(btn.route!)" [matTooltip]="btn.tooltip!"
					matTooltipPosition="right" [matMenuTriggerFor]="supportMenu">
					<mat-icon *ngIf="!btn.imgSrc"
						[ngClass]="btn.iconOutlined ? 'material-symbols-outlined':''"></mat-icon>
					<img *ngIf="btn.imgSrc" [src]="btn.imgSrc" class="mat-icon" alt="{{btn.label}}">
				</span>
				<span *ngSwitchDefault mat-button [class]="'app-icon app-icon--' + btn.iconClass"
					(click)="btn.clickFn ? btn.clickFn() : gotoRoute(btn.route!)" [matTooltip]="btn.tooltip!"
					matTooltipPosition="right">
					<mat-icon *ngIf="!btn.imgSrc"
						[ngClass]="btn.iconOutlined ? 'material-symbols-outlined':''"></mat-icon>
					<img *ngIf="btn.imgSrc" [src]="btn.imgSrc" class="mat-icon" alt="{{btn.label}}">
				</span>
			</ng-container>
			<mat-divider *ngIf="btn.dividerAfter"></mat-divider>
		</ng-container>
	</div>
</ng-template>

<!-- Menu for Settings Links -->
<mat-menu #settingsMenu [overlapTrigger]="false" yPosition="above" xPosition="after">
	<button mat-menu-item (click)="goToHierarchyManagement()">
		<mat-icon>account_tree</mat-icon><span>Hierarchy Management</span>
	</button>
	<button mat-menu-item (click)="goToDataModelManagement()">
		<mat-icon>schema</mat-icon><span>Data Model Management</span>
	</button>
	<button mat-menu-item (click)="goToDashboardManagement()">
		<mat-icon>dashboard</mat-icon><span>Dashboard Management</span>
	</button>
	<button mat-menu-item [routerLink]="['./setup/integration-management', selectedOrganisationUID]">
		<mat-icon>insights</mat-icon><span>Data Management</span>
	</button>
	<button *ngIf="checkFeature(AccountFeatures.Virtual_Sensors)" mat-menu-item [routerLink]="['./setup/virtual-datapoint-management', selectedOrganisationUID]">
		<mat-icon>mediation</mat-icon><span>Virtual DataPoints</span>
	</button>
	<button mat-menu-item [routerLink]="['./accounts-management',selectedAccountGUID]">
		<mat-icon>manage_accounts</mat-icon><span>Account Management</span>
	</button>

	<button *ngIf="thisUser && thisUser.AdminSite" mat-menu-item routerLink="./users-management">
		<mat-icon>person</mat-icon><span>User Management</span>
	</button>

	<!-- <button *ngIf="thisUser && thisUser.AdminSite" mat-menu-item routerLink="./feature-management">
		<mat-icon>extension</mat-icon><span>Feature Management</span>
	</button> -->
</mat-menu>

<mat-menu #changeOrganisation [overlapTrigger]="false" yPosition="below">
	<button mat-menu-item *ngFor="let org of Organisations">
		<a class="dropdown-item" (click)="SelectOrganisation(org.Uid)"
			[ngClass]="{'menuSelected': org.Uid === selectedOrganisation.Uid}">{{org?.Name}}</a>
	</button>
</mat-menu>

<mat-menu #userAccountMenu [overlapTrigger]="false" yPosition="below">
	<button mat-menu-item routerLink="./profile">
		<mat-icon>account_circle</mat-icon><span>My Profile</span>
	</button>
	<button id="inviteButton" mat-menu-item routerLink="./invite">
		<mat-icon>rsvp</mat-icon><span>My Invites</span>
		<ng-container *ngIf="(myInvites.length != 0) then NotificationBadge" />
	</button>
	<button mat-menu-item routerLink="./accounts-management">
		<mat-icon>manage_accounts</mat-icon><span>My Accounts</span>
	</button>
	<button mat-menu-item routerLink="./{{selectedAccountGUID}}/organisation/{{selectedOrganisationUID}}/favourites">
		<mat-icon>star</mat-icon><span>My Favourite Assets</span>
	</button>
	<mat-divider></mat-divider>
	<button mat-menu-item (click)="logout()">
		<mat-icon>exit_to_app</mat-icon><span>Logout</span>
	</button>
	<ng-container *ngIf="updateAvailable">
		<mat-divider></mat-divider>
		<button mat-menu-item (click)="reload()">
			<mat-icon>system_update</mat-icon><span>Update App</span>
			<ng-container *ngIf="updateAvailable then NotificationBadge" />
		</button>
	</ng-container>
</mat-menu>


<mat-menu #supportMenu [overlapTrigger]="false" yPosition="above" xPosition="after">
	<button mat-menu-item class="app-icon app-icon--bug"
		(click)="gotoRoute('github', 'https://github.com/malonegroup/PrismPdM-Website/issues')"
		matTooltip="Report Issue to GitHub" matTooltipPosition="right">
		<!-- <img src="'https://github.githubassets.com/favicons/favicon.svg" class="mat-icon" > -->
		<mat-icon>bug_report</mat-icon>
		<span>Report Issue to GitHub</span>
	</button>
	<button mat-menu-item class="app-icon app-icon--mail" (click)="gotoRoute('email', issueEmailLink)"
		matTooltip="Email Support" matTooltipPosition="right">
		<mat-icon />
		<span>Email Support</span>
	</button>
</mat-menu>

<ng-template #NotificationBadge>
	<span class="notification-badge" style="left:auto; right:0" matTooltipPosition="before"></span>
</ng-template>